import api from './client';

export const getStaffPerformance = (params) =>
  api.get('/reports/staff-performance', { params }).then(r => r.data);

export const getDistanceReport = (params) =>
  api.get('/reports/distance', { params }).then(r => r.data);

export const getJobsReport = (params) =>
  api.get('/reports/jobs', { params }).then(r => r.data);

export const getFuelCostReport = (params) =>
  api.get('/reports/fuel-cost', { params }).then(r => r.data);

// Sprint 2.10 GÖREV 3 — günlük mesai raporu (work_session + job events + KM)
export const getDailyWork = (params) =>
  api.get('/reports/daily-work', { params }).then(r => r.data);
